/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $NotifyOnEmployeeDocument = {
    properties: {
        document_id: {
    type: 'number',
    isRequired: true,
},
        notify_flag: {
    type: 'number',
    isRequired: true,
},
    },
};